import React, { useEffect, useState } from "react";
import {
    Col,
    Container,
    Row,
    Form,
    Button,
    Spinner,
    Table,
    Modal,
} from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { useSelector } from "react-redux";
import Pagination from "../../Common/Pagination";
import RejectButton from "../../Common/RejectButton";

const SurveyVerification = () => {
    const userState = useSelector((state) => state.loginData.userData);
    const financialYear = useSelector((state) => state.activeData.financialYear);

    const navigate = useNavigate();

    // Variables for Zone-Gat Visitors Data ------------
    const [contractor, setContractor] = useState();
    const [loader, setLoader] = useState(false);

    const [searchProperty, setSearchProperty] = useState("");
    const [searchPropErr, setSearchPropErr] = useState(false);

    // States for Pagination ----------
    const [pageNo, setPageNo] = useState(1);
    const [docPerPage, setDocPerPage] = useState(50);
    const [noOfPages, setNoOfPages] = useState(0);

    // function for pagination

    const handlePageChange = (pageNumber) => {
        setPageNo(pageNumber);
    };

    const handleDocsPerPage = (docsPageProp) => {
        setPageNo(1);
        setDocPerPage(docsPageProp);
    };


    //   useEffect API Calls
    useEffect(() => {
        getVisitReportList();
    }, [docPerPage, pageNo, financialYear]);


    // get survey list data
    const getVisitReportList = async () => {
        setLoader(true);
        await fetch(
            process.env.REACT_APP_BASE_URL +
            "/billDistribution/getAllBillDistributionsPGN",
            {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    propertyCode: searchProperty,
                    zoneno: '',
                    ...(userState?.usertype_keyname?.includes("zonalofficer")
                        ? {
                            zonename: userState?.usertype_keyname?.includes("zonalofficer") ? userState?.zonename : "",
                        }
                        : {}),
                    ...(userState?.usertype_keyname?.includes("gatlipik") && {
                        gatkey: userState?.gatkey
                    }),
                    visitingPersonContactNo: "",
                    financialYear: financialYear,
                    documentsPerPage: docPerPage,
                    page: pageNo,
                }),
            }
        )
            .then((res) => res.json())
            .then((response) => {
                if (response.status === 200) {
                    setContractor(response);
                    setNoOfPages(response.noOfPages);
                    setLoader(false);
                } else {
                    setContractor();
                    setNoOfPages(0);
                    setLoader(false);

                }
            })
            .catch((error) => {
                console.error(error);
                setLoader(false);
            });
    };


    const searchByProperty = async () => {
        if (searchProperty.length > 0) {
            getVisitReportList();
        } else {
            setSearchPropErr(true);
        }
    };

    return (
        <div className="visitReport">
            <ToastContainer />
            <Col
                md={4}
                className="searchCard m-2"
                style={{ paddingLeft: 10, paddingRight: 10, paddingBottom: 10 }}
            >
                <div className="label mb-2 mx-auto">
                    <p>Search by Property Code</p>
                </div>
                <div className="d-flex mt-1">
                    <Form.Control
                        placeholder="Property Code"
                        pattern="[0-9]*"
                        value={searchProperty}
                        onChange={(e) => {
                            if (!/^[0-9]*\.?[0-9]*$/.test(e.target.value)) {
                                e.target.setCustomValidity("Please enter only numbers.");
                            } else {
                                e.target.setCustomValidity("");
                                setSearchProperty(e.target.value);
                            }
                        }}
                    />

                    <Button
                        className="btn-submit ms-3"
                        onClick={() => searchByProperty()}
                    >
                        <Icon.Search className="me-2" size={14} />
                        Search
                    </Button>
                </div>
                {searchPropErr ? (
                    <p className="errMsg">Please enter valid property code</p>
                ) : null}
            </Col>
            <Container>
                <Row className="visitors mt-2">
                    <div className="container tbl-container p-0">
                        <div className="row tbl-fixed p-0" style={{ maxHeight: "65vh" }}>
                            <Table responsive="lg" hover>
                                <thead>
                                    <th>Sr No.</th>
                                    <th>Property Code</th>
                                    <th>Property Owner Name</th>
                                    <th>Property Owner Contact No</th>
                                    <th>Property Address</th>
                                    <th>Zone Name</th>
                                    <th>Gat Name</th>
                                    <th>Reject</th>
                                    <th>Action</th>
                                </thead>
                                <tbody>
                                    {loader ? (
                                        <center>
                                            <Spinner />
                                        </center>
                                    ) : contractor && contractor.data.length > 0 ? (
                                        contractor.data.map((row, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>
                                                        {pageNo !== 1 ? (
                                                            <> {index + 1 + docPerPage * (pageNo - 1)}</>
                                                        ) : (
                                                            <>{index + 1}</>
                                                        )}
                                                    </td>
                                                    <td>{row?.propertyCode ? row?.propertyCode : "-"}</td>
                                                    <td>{row?.propertyName ? row?.propertyName : "-"}</td>
                                                    <td>
                                                        {row?.propertyContactNo
                                                            ? row?.propertyContactNo
                                                            : "-"}
                                                    </td>
                                                    <td>
                                                        {row?.propertyAddress ? row?.propertyAddress : "-"}
                                                    </td>
                                                    <td>{row?.zonename ? row?.zonename : "-"}</td>
                                                    <td>{row?.gatname ? row?.gatname : "-"}</td>
                                                    <td>
                                                        <RejectButton
                                                            visitId={row}
                                                            refreshData={getVisitReportList}
                                                        />
                                                    </td>
                                                    <td className="text-center">
                                                        <Icon.Eye
                                                            className="me-2"
                                                            style={{ cursor: "pointer" }}
                                                            size={25}
                                                            onClick={() =>
                                                                navigate("/dashboard/surveyverificationView", {
                                                                    state: {
                                                                        report: row,
                                                                        comesFrom: "Survey Verification Report",
                                                                    },
                                                                })
                                                            }
                                                        />
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>No data found</tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                        <Row>
                            <Col md={4} className="d-flex align-items-center mt-3 mt-md-0">
                                <h6 className="text-start mb-0">
                                    <Icon.People className="me-2" />
                                    Total - <strong>{contractor?.count}</strong>
                                </h6>
                            </Col>
                            <Col md={8} className="d-flex justify-content-end">
                                <Pagination
                                    currentPage={pageNo}
                                    totalPages={noOfPages}
                                    onPageChange={handlePageChange}
                                    onDocsPerPage={handleDocsPerPage}
                                    docsPerPage={docPerPage}
                                />
                            </Col>
                        </Row>
                    </div>
                </Row>
            </Container>
        </div >
    );
};

export default SurveyVerification;
